import {
  getHierarchyTraits,
  postHierarchyTrait,
  putHierarchyTrait,
} from '../../../Api/services/backoffice';

export const key = 'hierarchyTrait';

const entityName = {
  singular: 'Alçada de Aprovação de Traços',
  plural: 'Alçadas de Aprovação de Traços',
};

const queries = {
  list: { key, fn: getHierarchyTraits },
  detail: { key },
};

const mutations = {
  create: postHierarchyTrait,
  update: putHierarchyTrait,
};

const fields = {
  table: [
    { key: 'approvalAuthority.approver', label: 'Hierarquia' },
    { key: 'rule', label: 'Regra' },
    { key: 'discount', label: 'Desconto' },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
};

export const createConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.create,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};
